export const formatSecondsAsClock = (seconds: number): string => {
  if (!isFinite(seconds) || isNaN(seconds) || seconds < 0) return '0:00'

  const totalSeconds = Math.floor(seconds)
  const minutes = Math.floor(totalSeconds / 60)
  const remainingSeconds = totalSeconds % 60

  return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`
}

export const clampToDuration = (value: number, duration: number): number => {
  if (!isFinite(duration) || isNaN(duration) || duration <= 0) return 0
  if (!isFinite(value) || isNaN(value) || value < 0) return 0
  return Math.min(value, duration)
}
